import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://200.198.9.108/api";

const getCidades = async () => {
  try {
    const response = await axios.get(`${API_URL}/cidades/MG`);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar cidades:", error);
  }
};

export default getCidades;
